import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSystemStore = defineStore('system', () => {
  const error = ref<Error | null>(null)

  const setError = (e: Error) => {
    console.error('SETTING ERROR:', e)
    error.value = e
  }

  const clearError = () => {
    error.value = null
  }

  const getError = () => {
    return error.value
  }

  const hasError = () => {
    return error.value !== null
  }

  return {
    setError,
    clearError,
    getError,
    hasError,
  }
})
